import React from 'react';
import { Layout } from '../components/Layout';

export default function Terms() {
    return (
        <Layout>
            <div className="min-h-screen py-24">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="font-brand text-4xl md:text-5xl uppercase mb-8">
                        Terms of <span className="text-primary">Service</span>
                    </h1>
                    
                    <div className="prose prose-invert prose-sm max-w-none space-y-6 text-muted-foreground">
                        <p className="text-foreground">
                            Last updated: February 1, 2026
                        </p>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">1. Acceptance of Terms</h2>
                            <p>
                                By accessing or using SubHack ("the Service"), owned and operated by All The Rage Ventures, LLC ("COMPANY", "we", or "us"), 
                                you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">2. Description of Service</h2>
                            <p>
                                SubHack is a web application that allows users to add custom subtitles to video clips 
                                and share them via unique URLs. The Service includes both free and paid subscription tiers.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">3. User Accounts</h2>
                            <p>
                                To access certain features, you must create an account. You are responsible for:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>Maintaining the confidentiality of your account credentials</li>
                                <li>All activities that occur under your account</li>
                                <li>Providing accurate and complete information</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">4. Acceptable Use</h2>
                            <p>
                                You agree not to use the Service to:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>Create content that is illegal, harmful, threatening, abusive, harassing, defamatory, or otherwise objectionable</li>
                                <li>Infringe on any third party's intellectual property rights</li>
                                <li>Distribute spam, malware, or other harmful content</li>
                                <li>Attempt to gain unauthorized access to the Service or its systems</li>
                                <li>Circumvent any content moderation or access controls</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">5. Subscriptions and Payments</h2>
                            <p>
                                Pro subscriptions are billed through our payment partner, Lemon Squeezy. By subscribing:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>You authorize recurring charges to your payment method.</li>
                                <li>You may cancel at any time; access continues until the end of the billing period.</li>
                                <li><strong>Refund Policy:</strong> Payments are non-refundable except as required by law. You may cancel your subscription at any time to prevent future billing.</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">6. Intellectual Property Rights</h2>
                            <p>
                                <strong>Our License to You:</strong> The Service and its original content, features, and functionality are owned by COMPANY and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
                            </p>
                            <p>
                                <strong>Your License to Us:</strong> You retain ownership of the subtitles and remixes you create. However, by creating and sharing content via SubHack, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, translate, and display such content for the purpose of providing and improving the Service.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">7. Disclaimer of Warranties</h2>
                            <p className="uppercase">
                                THE SERVICE IS PROVIDED "AS IS" AND WITHOUT WARRANTIES OF ANY KIND EITHER EXPRESS OR IMPLIED. 
                                TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, 
                                INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. 
                                WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">8. Limitation of Liability</h2>
                            <p className="uppercase">
                                UNDER NO CIRCUMSTANCES SHALL COMPANY BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES 
                                THAT RESULT FROM THE USE OF, OR THE INABILITY TO USE, THE SERVICE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. 
                                IN NO EVENT SHALL OUR TOTAL LIABILITY TO YOU EXCEED THE AMOUNT PAID BY YOU, IF ANY, FOR ACCESSING THE SERVICE.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">9. Copyright & DMCA</h2>
                            <p>
                                We respond to notices of alleged copyright infringement according to the US Digital Millennium Copyright Act (DMCA).
                                If you believe your work has been copied in a way that constitutes copyright infringement, please forward the following 
                                information to our Copyright Agent at <span className="text-primary">dmca@atrv.io</span>:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>A description of the copyrighted work</li>
                                <li>The specific location (URL) of the infringing material on SubHack</li>
                                <li>Your contact information</li>
                                <li>A statement that you have a good faith belief the use is unauthorized</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">10. Dispute Resolution</h2>
                            <p>
                                <strong>Governing Law:</strong> These Terms shall be governed by and construed in accordance with the laws of the state of New York.
                            </p>
                            <p>
                                <strong>Binding Arbitration:</strong> Any dispute arising from these Terms or your use of the Service shall be subject to binding arbitration by NAM (National Arbitration and Mediation) in Harrison, New York.
                            </p>
                            <p>
                                <strong>Class Action Waiver:</strong> You may only resolve disputes with us on an individual basis and may not bring a claim as a plaintiff or a class member in a class, consolidated, or representative action.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">11. Severability & Assignment</h2>
                            <p>
                                If any provision of these Terms is found to be unenforceable, that provision shall be severed, and the remainder of the Terms shall remain in full force and effect.
                                We may assign our rights and obligations under these Terms to any party at any time without notice to you. You may not assign your rights or obligations without our prior written consent.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">12. Contact</h2>
                            <p>
                                For questions about these terms, contact us at subhacksupport@atrv.io
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}